import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PermissionStoreEffects } from './effects';
import { PermissionReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature('Permissions', PermissionReducer), EffectsModule.forFeature([PermissionStoreEffects])],
})
export class PermissionStoreModule {}
